import React from 'react';

const TerminalLoader = () => {
  return (
    <>
      <style>{`
        .xp-loader-container {
          background-color: black;
          height: 100vh;
          width: 100vw;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin: 0;
          font-family: 'Tahoma', 'Segoe UI', sans-serif;
          color: white;
          user-select: none;
        }

        .xp-logo {
          font-size: 2.5rem;
          font-weight: bold;
          margin-bottom: 4rem;
          display: flex;
          align-items: baseline;
          letter-spacing: -1px;
        }

        .xp-logo-microsoft {
          font-weight: normal;
          font-size: 1.2rem;
          margin-right: 8px;
          position: relative;
          top: -15px;
        }

        .xp-logo-xp {
          color: #ff6600; /* Classic XP orange */
          font-style: italic;
          font-size: 2.8rem;
          margin-left: 10px;
          font-family: 'Arial Black', sans-serif;
        }

        /* The iconic scrolling bar container */
        .xp-loading-bar-container {
          width: 250px;
          height: 18px;
          border: 2px solid #b3b3b3;
          border-radius: 5px;
          position: relative;
          overflow: hidden;
          background-color: black;
          padding: 2px;
          box-sizing: border-box;
        }

        /* The 3 blue squares that move */
        .xp-loading-blocks {
          display: flex;
          gap: 2px;
          height: 100%;
          width: 30px;
          position: absolute;
          left: -40px;
          animation: scan 2.5s infinite linear;
        }

        .xp-block {
          flex: 1;
          /* The classic blue gradient */
          background: linear-gradient(to bottom, #2838c7 0%, #5979fa 40%, #5979fa 60%, #2838c7 100%);
          border-radius: 1px;
        }

        @keyframes scan {
          0% { left: -40px; }
          100% { left: 260px; }
        }
      `}</style>

      <div className="xp-loader-container">
        <div className="xp-logo">
          <span className="xp-logo-microsoft">Niza</span>
          Siwale
        </div>
        
        <div className="xp-loading-bar-container">
          <div className="xp-loading-blocks">
            <div className="xp-block"></div>
            <div className="xp-block"></div>
            <div className="xp-block"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TerminalLoader;


